export default {
    currency: (field) => {
        return field.replace('!', '');
    }
};

export const competenceMapper = options => {
    let selectOptions = [];
    let currentLabelId = null;

    if (options && options.length) {
        options.sort((a, b) => a.labelId - b.labelId).forEach(option => {
            if (currentLabelId !== option.labelId) {
                selectOptions.push({
                    ...option,
                    id: `${option.labelId}${option.id}`,
                    name: option.label,
                    disabled: true,
                });

                currentLabelId = option.labelId;
            }

            selectOptions.push({
                ...option,
                name: `    ${option.name}`,
            });
        });
    }

    return selectOptions;
}
